import { URL_CREATE_USER_API } from 'constants/urls';

async function createUserApi(user) {
	const options = {
		method: 'POST',
		headers: { 'Content-Type': 'application/json;charset=UTF-8' },
		body: JSON.stringify({ payload: user }),
	};

	const res = await fetch(URL_CREATE_USER_API, options);
	const data = await res.json();

	if (!data.Success) {
		throw new Error(data.Message);
	} else {
		return data;
	}
}

export default createUserApi;
